/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_10_AInputs */

const en_tut_tr_10_a = /** @type {(inputs: Tut_Tr_10_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three common reasons: the host disconnected before the recording finished, so the unfinished file was discarded; the recording is older than 30 days; or it was a private desk call and the desk has since been released or changed hands — desk recordings are deleted when that happens. Download the MP4 while it is there if you need it.`)
};

const id_tut_tr_10_a = /** @type {(inputs: Tut_Tr_10_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada tiga sebab yang paling sering: host terputus sebelum rekaman selesai sehingga hasil yang belum final dibuang; rekaman sudah lewat 30 hari; atau itu rekaman panggilan meja pribadi dan mejanya sudah dilepas atau berpindah tangan — rekaman meja memang ikut dihapus saat itu terjadi. Unduh MP4 selagi masih ada kalau memang dibutuhkan.`)
};

/**
* | output |
* | --- |
* | "Three common reasons: the host disconnected before the recording finished, so the unfinished file was discarded; the recording is older than 30 days; or it w..." |
*
* @param {Tut_Tr_10_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_10_a = /** @type {((inputs?: Tut_Tr_10_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_10_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_10_a(inputs)
	return en_tut_tr_10_a(inputs)
});